/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Desc_Toggle_RewindInputs */

const en_shortcut_keys_desc_toggle_rewind = /** @type {(inputs: Shortcut_Keys_Desc_Toggle_RewindInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rewind through video (foot fedal recommended)`)
};

const fr_shortcut_keys_desc_toggle_rewind = /** @type {(inputs: Shortcut_Keys_Desc_Toggle_RewindInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retour rapide dans la video (pedale recommandee)`)
};

const de_shortcut_keys_desc_toggle_rewind = /** @type {(inputs: Shortcut_Keys_Desc_Toggle_RewindInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Video zurückspulen (Fußfesselung empfohlen)`)
};

const it_shortcut_keys_desc_toggle_rewind = /** @type {(inputs: Shortcut_Keys_Desc_Toggle_RewindInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Riavvolgi il video (si consiglia l'uso del piede)`)
};

const ru_shortcut_keys_desc_toggle_rewind = /** @type {(inputs: Shortcut_Keys_Desc_Toggle_RewindInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Перемотайте видео (рекомендуется использовать педаль).`)
};

const es_shortcut_keys_desc_toggle_rewind = /** @type {(inputs: Shortcut_Keys_Desc_Toggle_RewindInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rebobinar el video (se recomienda usar el pie)`)
};

const zh_cn2_shortcut_keys_desc_toggle_rewind = /** @type {(inputs: Shortcut_Keys_Desc_Toggle_RewindInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`视频倒带（建议使用脚踏式播放器）`)
};

const ja_shortcut_keys_desc_toggle_rewind = /** @type {(inputs: Shortcut_Keys_Desc_Toggle_RewindInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ビデオを巻き戻す（徒歩での視聴を推奨）`)
};

const hi_shortcut_keys_desc_toggle_rewind = /** @type {(inputs: Shortcut_Keys_Desc_Toggle_RewindInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वीडियो को रिवाइंड करके देखें (फुट पैडल का इस्तेमाल करने की सलाह दी जाती है)`)
};

const pt_pt2_shortcut_keys_desc_toggle_rewind = /** @type {(inputs: Shortcut_Keys_Desc_Toggle_RewindInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retroceda o vídeo (recomenda-se o uso do pedal)`)
};

/**
* | output |
* | --- |
* | "Rewind through video (foot fedal recommended)" |
*
* @param {Shortcut_Keys_Desc_Toggle_RewindInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_desc_toggle_rewind = /** @type {((inputs?: Shortcut_Keys_Desc_Toggle_RewindInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Desc_Toggle_RewindInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shortcut_keys_desc_toggle_rewind(inputs)
	if (locale === "de") return de_shortcut_keys_desc_toggle_rewind(inputs)
	if (locale === "it") return it_shortcut_keys_desc_toggle_rewind(inputs)
	if (locale === "ru") return ru_shortcut_keys_desc_toggle_rewind(inputs)
	if (locale === "es") return es_shortcut_keys_desc_toggle_rewind(inputs)
	if (locale === "zh-CN") return zh_cn2_shortcut_keys_desc_toggle_rewind(inputs)
	if (locale === "ja") return ja_shortcut_keys_desc_toggle_rewind(inputs)
	if (locale === "hi") return hi_shortcut_keys_desc_toggle_rewind(inputs)
	if (locale === "pt-PT") return pt_pt2_shortcut_keys_desc_toggle_rewind(inputs)
	return en_shortcut_keys_desc_toggle_rewind(inputs)
});